export enum ConversationFilterStatus {
    ACTIVE = 'Active',
    RESOLVED = 'Resolved',
    ALL = 'All',
    WITH_CLIENT = 'With Client',
    WITH_CLINIC = 'With Clinic',
}
